import {
  ButtonsDropdownOption,
  Dropdown,
  dropdownTypes,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { ChevronDown, Download } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { showErrorModal } from "slices/app/actions/error";
import {
  selectIsLockedByAnotherUser,
  selectOutlineOwnerName,
  selectProposalOutlineSections,
} from "slices/proposalOutline/selectors";

import { downloadOutlineExcel } from "../../outlineExcel";
import { handleStopPropagation } from "./utils";

const ExportDropdownButton = () => {
  const ownerName = useSelector(selectOutlineOwnerName);
  const sections = useSelector(selectProposalOutlineSections);
  const isLockedByOtherUser = useSelector(selectIsLockedByAnotherUser);
  const dispatch = useDispatch();

  const hasNoSections = sections.length === 0;

  const onClickExport = async () => {
    if (hasNoSections) {
      return;
    }

    try {
      await downloadOutlineExcel(sections, ownerName);
    } catch (error) {
      dispatch(
        showErrorModal(error, "Failed to export the outline. Please try again.")
      );
    }
  };

  return (
    <Dropdown
      onOpenChange={handleStopPropagation}
      type={dropdownTypes.buttons}
      propsObject={{
        text: "Export",
        buttonVariant: NewButtonVariant.l2,
        leftIcon: <Download size={16} />,
        rightIcon: <ChevronDown size={16} />,
        disabled: isLockedByOtherUser,
        options: [
          <ButtonsDropdownOption
            key="export-excel-option"
            content="Excel (xlsx)"
            disabled={hasNoSections}
            title={hasNoSections ? "No sections to export" : undefined}
            onClick={onClickExport}
          />,
        ],
        closeOnMouseLeave: true,
      }}
    />
  );
};

export default ExportDropdownButton;
